var React = require('react');

function IcAwsEc2ElasticIp (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M39.744,19.35l-5.822-6.272l-1.4,1.301l4.331,4.665H16.191c-0.475-4.031-3.908-7.17-8.065-7.17\n\tC3.645,11.874,0,15.519,0,20c0,4.48,3.645,8.126,8.126,8.126c4.157,0,7.589-3.139,8.065-7.17h20.661l-4.33,4.664l1.4,1.301\n\tl5.822-6.271C40.085,20.284,40.085,19.716,39.744,19.35z M8.126,26.214c-3.426,0-6.214-2.788-6.214-6.214s2.788-6.214,6.214-6.214\n\tS14.34,16.574,14.34,20S11.553,26.214,8.126,26.214z M37.705,20.037v-0.074L37.74,20L37.705,20.037z"}));
}

IcAwsEc2ElasticIp.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsEc2ElasticIp;

IcAwsEc2ElasticIp.default = IcAwsEc2ElasticIp;
